<div class="relative inline-block w-full">
    <!-- Main input field -->
    <div class="w-full" [formGroup]="formGroup">
        @if(slot.label) {
            <label class="block text-[14px] font-medium text-foreground opacity-80 mb-2">
                {{ slot.label }}
            </label>
        }
        <div class="relative">
            @if(slot.icon) {
                <i 
                    class="absolute left-3 top-1/2 transform -translate-y-1/2 hidden sm:flex icon-size-5 text-muted-foreground"
                    [class]="slot.icon"
                ></i>
            }
            <input
                z-input
                class="custom-text-input"
                [class]="(slot.icon ? 'pl-10' : '') + (hasOperatorOptions ? ' pr-8' : '')"
                [formControlName]="slot.field"
                [spellcheck]="false"
            />
            @if(hasOperatorOptions) {
                <button
                    type="button"
                    class="absolute right-0 top-0 bottom-0 w-8 flex items-center justify-center cursor-pointer text-muted-foreground hover:text-foreground z-10 border-l border-border"
                    (click)="toggleOperatorSelection($event)"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m0 0h8.25m-8.25 0a1.5 1.5 0 0 1-3 0M3.75 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m12.75 0h3.375m-3.375 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0M3.75 18h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0" />
                    </svg>
                </button>
            }
        </div>
    </div>

    @if(showOperatorSelection) {
    <div
        class="absolute top-0 right-0 mt-12 bg-background border border-border rounded-md shadow-lg p-3 w-60 z-50"
    >
        <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-foreground">
                {{ 'filters.operators.name' | transloco }}
            </span>
            <button
                type="button"
                class="cursor-pointer text-muted-foreground hover:text-foreground"
                (click)="toggleOperatorSelection()"
            >
                <i class="icon-x-mark size-4"></i>
            </button>
        </div>

        @if(slot.operatorOptions && slot.operatorOptions.length > 1) {
            <!-- Multiple Operators -->
            <div [formGroup]="formGroup">
                <z-select 
                    [formControlName]="slot.field + '_operator'"
                    placeholder="Select operator"
                    class="w-full"
                >
                    @for(op of slot.operatorOptions; track op) {
                        <z-select-item [value]="op">{{ getOperatorLabel(op) }}</z-select-item>
                    }
                </z-select>
            </div>
        } @else if(slot.operatorOptions && slot.operatorOptions.length === 1) {
            <!-- Single Operator -->
            <div class="flex items-center gap-2 mb-2">
                <span class="text-sm font-semibold text-foreground">
                    {{ getOperatorLabel(slot.operatorOptions[0]) }}
                </span>
            </div>
        }
    </div>
    }
</div>
